var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoman1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 457.574 457.574",
    style: {
      enableBackground: "new 0 0 457.574 457.574"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B974"
    },
    d: "M130.107,315.194l-0.81-0.62c0,0-20-67,38-105s55-133,55-133s99,58,86,177 c-1.6,14.62-3.32,27.28-5.1,38.41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M130.107,315.194l-0.81-0.62c0,0-20-67,38-105 s55-133,55-133s99,58,86,177c-1.6,14.62-3.32,27.28-5.1,38.41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M278.147,280.544c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19v84.89h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M158.307,327.574v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C155.317,303.694,158.307,315.284,158.307,327.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M346.307,366.684v84.89h-47.04v-124c0-12.29,2.99-23.88,8.29-34.08 C330.947,309.414,346.307,336.264,346.307,366.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M348.287,372.884v15.69c-11.64-7.61-22.69-2.39-31.33,5.69c1.14-36.58,7.05-75.54,8.16-82.57 c6.98,8.2,12.59,17.33,16.53,27.14C345.947,349.494,348.287,360.944,348.287,372.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A88D6"
    },
    d: "M158.307,386.574v30.1c-4.67-8.62-25.18-43.02-48.01-28.1h-0.51v-15.69c0-13.4,2.94-26.2,8.3-37.94 c3.19-6.99,7.23-13.61,12.02-19.75c5.84-7.51,12.8-14.31,20.65-20.24c4.84,9.84,7.55,20.91,7.55,32.62V386.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M305.267,451.574h-12v-124c0-12.816,3.101-25.558,8.966-36.846l10.648,5.533 c-5.053,9.724-7.614,20.259-7.614,31.313V451.574z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M154.957,305.494c-15.21,15.89-24.56,37.45-24.56,61.19 v82.89h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C151.997,297.314,153.657,301.324,154.957,305.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M263.272,427.574h-68.96c-23.159,0-42-18.841-42-42h12c0,16.542,13.458,30,30,30h68.96 c16.542,0,30-13.458,30-30h12C305.272,408.732,286.431,427.574,263.272,427.574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M270.584,271.574v65.36c0,14.71-11.93,26.64-26.64,26.64h-30.72c-14.71,0-26.64-11.93-26.64-26.64 v-65.36c12.5,6.75,26.8,10.58,41.99,10.58C243.784,282.154,258.084,278.324,270.584,271.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M243.944,369.574h-30.72c-17.998,0-32.64-14.642-32.64-32.64v-65.36h12v65.36 c0,11.381,9.259,20.64,20.64,20.64h30.72c11.381,0,20.641-9.259,20.641-20.64v-65.36h12v65.36 C276.584,354.931,261.942,369.574,243.944,369.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M228.584,369.574c-3.313,0-6-2.687-6-6v-15c0-3.313,2.687-6,6-6s6,2.687,6,6v15 C234.584,366.887,231.898,369.574,228.584,369.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M270.584,269.574c-1.18,2.25,1.37,16.06,0,18.18 c-6.42,10.03-14.81,18.67-24.62,25.39c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-31.08,15.03-49.36,15.03 c-5.24,0-6.11-4.72-9.44-7.26v-49.74c11.87,5.92,29.24,12,43.41,12C247.854,283.574,256.684,278.664,270.584,269.574z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M317.297,118.074v74c0,30.35-15.28,57.13-38.56,73.07c-0.19,0.14-0.4,0.27-0.58,0.4 c-0.17,0.11-0.33,0.22-0.5,0.33c-14,9.29-30.79,14.7-48.87,14.7c-18.27,0-35.25-5.54-49.35-15.03c-0.2-0.13-0.4-0.26-0.58-0.4 c-4.9-3.35-9.44-7.18-13.55-11.43c-12.21-12.56-20.72-28.73-23.77-46.77c-0.82-4.83-1.25-9.8-1.25-14.87v-74 c0-3.1,0.16-6.16,0.47-9.18c2.79-27.11,17.82-50.58,39.47-64.81c13.94-9.18,30.63-14.51,48.56-14.51h0.01c0.42,0,0.84,0,1.26,0.02 c5.98,0.07,11.82,0.75,17.46,1.97C287.397,40.144,317.297,75.614,317.297,118.074z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7774B"
    },
    d: "M228.792,239.583c-4.869,0-9.738-0.513-14.572-1.538c-3.242-0.688-5.313-3.873-4.625-7.114 c0.687-3.241,3.874-5.313,7.113-4.625c8.02,1.7,16.148,1.7,24.168,0c3.24-0.685,6.427,1.384,7.113,4.625 c0.688,3.242-1.383,6.427-4.625,7.114C238.53,239.071,233.661,239.583,228.792,239.583z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M229.297,252.574h-1.01c-2.209,0-4-1.791-4-4s1.791-4,4-4h1.01c2.209,0,4,1.791,4,4 S231.506,252.574,229.297,252.574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M284.265,163.988c-0.452,0-0.912-0.052-1.372-0.159c-7.916-1.853-16.285-1.853-24.201,0 c-3.229,0.757-6.455-1.249-7.209-4.476c-0.755-3.227,1.248-6.454,4.475-7.209c9.705-2.27,19.963-2.271,29.67,0 c3.227,0.755,5.229,3.982,4.475,7.209C289.455,162.119,286.989,163.987,284.265,163.988z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M210.432,265.544c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07v-22.5c0-139,54.89-137.301,54.89-134.411L184.798,50.97 c-15.364,23.387-15.305,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 c-0.407,0.021-0.817,0.031-1.229,0.031v22.5c0,30.35,15.28,57.13,38.56,73.07C210.042,265.284,210.242,265.414,210.432,265.544z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 263.132,
    cy: 180.69,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M278.461,187.781c-1.539,0-3.077-0.588-4.249-1.764c-2.527-2.537-6.39-3.184-9.607-1.611 c-2.977,1.457-6.57,0.221-8.025-2.756c-1.455-2.977-0.222-6.57,2.756-8.025c7.83-3.827,17.223-2.251,23.375,3.919 c2.34,2.347,2.334,6.146-0.013,8.485C281.527,187.198,279.993,187.781,278.461,187.781z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M221.849,212.574c-3.313,0-6-2.687-6-6v-32.926c0-2.693-1.515-5.196-3.858-6.376 c-7.192-3.621-19.527-7.153-37.439-3.412c-3.248,0.676-6.422-1.403-7.1-4.647s1.403-6.422,4.646-7.1 c21.303-4.446,36.388-0.041,45.289,4.44c6.453,3.25,10.462,9.8,10.462,17.094v32.926 C227.849,209.887,225.162,212.574,221.849,212.574z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M228.787,286.574c-12.504,0-24.665-2.411-36.146-7.167c-5.78-2.388-11.354-5.379-16.558-8.888 c-0.213-0.138-0.473-0.313-0.726-0.499c-14.852-10.197-26.433-24.311-33.497-40.826l11.033-4.72 c6.184,14.456,16.333,26.807,29.353,35.719c0.095,0.065,0.188,0.133,0.279,0.204c0.035,0.023,0.11,0.07,0.184,0.118 c4.619,3.113,9.477,5.72,14.519,7.803c10.022,4.151,20.64,6.255,31.56,6.255c11.016,0,21.692-2.128,31.736-6.326 c4.969-2.061,9.747-4.628,14.219-7.638c0.109-0.077,0.224-0.155,0.34-0.232l0.12-0.082c0.053-0.038,0.092-0.066,0.146-0.103 c12.492-8.554,22.391-20.338,28.625-34.079l10.928,4.958c-7.13,15.713-18.44,29.191-32.711,38.979 c-0.138,0.099-0.28,0.196-0.421,0.29l-0.109,0.074c-0.027,0.02-0.119,0.084-0.147,0.103c-5.152,3.474-10.662,6.438-16.376,8.807 C253.634,284.133,241.4,286.574,228.787,286.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M272.297,277.574l-12.514,105.265 c-2.559,21.524-42.486,37.734-42.486,37.734h84l14-122L272.297,277.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M317.297,118.074v74c0,30.35-15.28,57.13-38.56,73.07 c-0.19,0.14-0.4,0.27-0.58,0.4c-0.17,0.11-0.33,0.22-0.5,0.33c0.5-4.02,0.98-8.2,1.46-12.56c13-119-86-177-86-177 s2.88,91.22-51.58,130.63c-0.82-4.83-1.25-9.8-1.25-14.87v-74c0-3.1,0.16-6.16,0.47-9.18c2.79-27.11,17.82-50.58,39.47-64.81 c13.94-9.18,30.63-14.51,48.56-14.51h0.01c0.42,0,0.84,0,1.26,0.02c5.98,0.07,11.82,0.75,17.46,1.97 C287.397,40.144,317.297,75.614,317.297,118.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M318.297,35.574c-53.56-53.56-102-18-102-18s-21-18-51,1s-98,108-48,316l0.79,0.37 c3.19-6.99,7.23-13.61,12.02-19.75l-0.81-0.62c0,0-20-67,38-105s55-133,55-133s99,58,86,177c-1.6,14.62-3.32,27.28-5.1,38.41 c-12.74,79.41-28.9,80.65-28.9,159.59h48v-1c-13.15-33.81,1.04-127.58,2.82-138.88c6.98,8.2,12.59,17.33,16.53,27.14l0.65-0.26 C342.297,338.574,389.297,106.574,318.297,35.574z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M216.297,17.574c0,0-21-18-51,1s-98,108-48,316l0.79,0.37c3.19-6.99,7.23-13.61,12.02-19.75 l-0.81-0.62c0,0-15.597-52.287,20.753-90.678c-7.299-130.04,41.051-190.114,65.064-205.322"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M299.793,296.925c-11.489-7.915-24.423-13.745-38.441-17.328l2.971-11.626 c15.396,3.934,29.62,10.351,42.279,19.072L299.793,296.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M392.287,457.574h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6 S395.601,457.574,392.287,457.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M76.287,457.574h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6 S79.601,457.574,76.287,457.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M280.297,451.574h-12c0-47.919,5.88-67.834,13.323-93.048c4.953-16.778,10.567-35.794,15.653-67.493 c1.869-11.697,3.572-24.521,5.059-38.112c5.215-47.734-7.191-91.056-36.875-128.761c-13.867-17.616-28.368-29.733-37.343-36.373 c-0.451,9.878-1.81,25.234-5.718,42.37c-8.856,38.833-26.772,68.03-51.812,84.435c-22.473,14.724-35.281,35.703-38.07,62.356 c-2.102,20.076,2.485,35.753,2.531,35.909l-11.498,3.433c-0.219-0.731-5.316-18.157-2.969-40.591 c2.188-20.909,11.499-50.224,43.43-71.144c54.554-35.742,52.32-126.875,52.291-127.792c-0.069-2.183,1.054-4.231,2.932-5.347 s4.213-1.123,6.099-0.019c1.051,0.615,26,15.417,49.557,45.34c21.79,27.68,46.311,74.002,39.375,137.488 c-1.509,13.789-3.238,26.811-5.14,38.706c-5.208,32.46-10.938,51.869-15.993,68.992 C285.96,386.207,280.297,405.388,280.297,451.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M348.178,339.765l-11.762-2.382c0.464-2.289,45.549-229.656-22.361-297.566 c-20.85-20.85-43.102-30.058-66.147-27.368c-17.031,1.988-27.951,9.883-28.06,9.962c-2.249,1.651-5.339,1.533-7.455-0.281 c-0.7-0.582-18.229-14.735-43.886,1.513c-5.603,3.549-34.415,24.262-51.442,83.708c-17.396,60.735-15.354,136.711,6.066,225.821 l-11.668,2.805c-21.91-91.147-23.907-169.18-5.934-231.929c14.116-49.287,38.472-79.088,56.558-90.542 c26.095-16.527,46.313-8.021,54.359-3.122c5.292-3.064,15.942-8.205,30.07-9.854c33.459-3.914,59.814,14.593,76.022,30.802 c30.684,30.683,44.268,92.127,40.377,182.625C360.054,280.533,348.296,339.18,348.178,339.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.291,30.367c-3.002,0-5.595-2.25-5.952-5.305c-0.384-3.292,1.973-6.271,5.265-6.655 c2.314-0.27,4.659-0.407,6.971-0.407c3.313,0,6,2.687,6,6s-2.687,6-6,6c-1.848,0-3.726,0.11-5.58,0.326 C249.758,30.354,249.524,30.367,249.291,30.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.654,253.575c-0.176,0-0.354-0.008-0.531-0.023c-3.302-0.29-5.742-3.201-5.452-6.502 c1.048-11.937,1.818-23.652,2.291-34.819c3.406-80.366-7.533-135.584-31.635-159.686c-7.148-7.148-14.474-12.673-21.773-16.421 c-2.948-1.514-4.111-5.13-2.598-8.078c1.515-2.948,5.134-4.11,8.078-2.597c8.411,4.318,16.747,10.58,24.777,18.61 c26.54,26.54,38.691,84.869,35.14,168.679c-0.479,11.347-1.263,23.244-2.327,35.361 C342.351,251.221,339.731,253.575,336.654,253.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.013,287.574c-0.25,0-0.502-0.016-0.756-0.047c-3.288-0.413-5.618-3.413-5.205-6.701 c0.587-4.672,1.141-9.353,1.645-13.912c0.364-3.294,3.327-5.67,6.624-5.304c3.293,0.364,5.668,3.33,5.304,6.623 c-0.511,4.618-1.071,9.357-1.666,14.088C338.577,285.355,335.992,287.574,333.013,287.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M164.307,451.574h-12v-124c0-10.534-2.333-20.617-6.934-29.972c-0.223-0.454-0.45-0.899-0.678-1.336 l10.643-5.543c0.272,0.523,0.545,1.057,0.807,1.591c5.415,11.008,8.162,22.874,8.162,35.26L164.307,451.574L164.307,451.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M115.787,451.574h-12v-78.69c0-13.979,2.975-27.582,8.842-40.432 c3.364-7.371,7.653-14.419,12.747-20.948c6.123-7.874,13.447-15.054,21.765-21.337c13.592-10.253,29.168-17.692,46.297-22.112 l2.998,11.619c-15.591,4.023-29.744,10.776-42.065,20.071c-7.474,5.646-14.045,12.084-19.527,19.133 c-4.522,5.797-8.322,12.039-11.298,18.558c-5.147,11.275-7.758,23.202-7.758,35.449L115.787,451.574L115.787,451.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M360.287,457.574H97.517c-3.313,0-6-2.687-6-6s2.687-6,6-6h262.771c3.313,0,6,2.687,6,6 S363.601,457.574,360.287,457.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M316.705,452.75c-4.65-11.952-6.584-31.692-5.745-58.673c1.152-37,7.059-75.897,8.23-83.319 c0.366-2.315,2.046-4.205,4.302-4.84c2.252-0.633,4.676,0.102,6.194,1.887c7.494,8.805,13.392,18.492,17.527,28.793 c4.692,11.63,7.073,23.841,7.073,36.286v78.69h-12v-78.69c0-10.899-2.088-21.6-6.205-31.805c-1.942-4.836-4.326-9.522-7.133-14.026 c-2.171,16.066-5.21,42.203-5.995,67.398c-0.777,25,0.929,43.655,4.935,53.947L316.705,452.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M153.902,421.2c-0.029-0.059-0.327-0.665-0.871-1.667c-6.447-11.902-17.061-25.561-27.513-28.205 c-4.109-1.038-8.014-0.296-11.939,2.268l-6.564-10.045c6.794-4.44,14.011-5.738,21.446-3.856 c17.399,4.4,30.357,25.328,35.121,34.121c0.731,1.349,1.112,2.137,1.112,2.137L153.902,421.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M321.056,398.646l-8.197-8.765c12.841-12.008,26.59-14.253,38.712-6.33l-6.566,10.044 C335.219,387.199,326.65,393.414,321.056,398.646z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman1);
export default __webpack_public_path__ + "static/media/woman1.6f4b3bdd8594fd0eea99b0e73015d9ae.svg";
export { ForwardRef as ReactComponent };